import { render, staticRenderFns } from "./CardOverview.vue?vue&type=template&id=4a81e16a&scoped=true&"
import script from "./CardOverview.vue?vue&type=script&lang=js&"
export * from "./CardOverview.vue?vue&type=script&lang=js&"
import style0 from "./CardOverview.vue?vue&type=style&index=0&id=4a81e16a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a81e16a",
  null
  
)

export default component.exports